import { PricingDuration } from '@buggy/shared'
import { I18nId } from '@/i18n/config'
import { Nullable } from '@/types/nullable'
import { Optional } from '@/types/optional'

export interface Duration {
  type: PricingDuration
  label: I18nId
  discountLabel?: I18nId
  value: number
}

export enum DurationType {
  OneDay = 1,
  Month = 30,
  Quarter = 90,
  HalfYear = 180,
  Year = 365,
}

export const DURATION_PLAN_BTN_I18N_MAP: Record<Duration['type'], I18nId> = {
  month: 'general:plan_month_btn',
  quarter: 'general:plan_quarter_btn',
  halfYear: 'general:plan_half_year_btn',
  year: 'general:plan_year_btn',
  oneDay: 'general:plan_oneDay_btn',
}

export const DURATION_PLAN_ACT_I18N_MAP: Record<DurationType, I18nId> = {
  1: 'general:plan_day_act',
  30: 'general:plan_month_act',
  90: 'general:plan_quarter_act',
  180: 'general:plan_half_year_act',
  365: 'general:plan_year_act',
}

export const DURATION_PLAN_I18N_MAP: Record<DurationType, I18nId> = {
  1: 'general:plan_oneDay_btn',
  30: 'vip:plan_month',
  90: 'vip:plan_quarter',
  180: 'vip:plan_half_year',
  365: 'vip:plan_year',
}

const DURATIONS: Duration[] = [
  {
    type: PricingDuration.OneDay,
    label: 'workspace:workspace_plan_time_unit4',
    value: 1,
  },
  {
    type: PricingDuration.Month,
    label: 'workspace:workspace_plan_time_unit1',
    value: 30,
  },
  {
    type: PricingDuration.Quarter,
    label: 'workspace:workspace_plan_time_unit2',
    value: 90,
    discountLabel: 'payment:quarter_discount',
  },
  {
    type: PricingDuration.HalfYear,
    label: 'workspace:workspace_plan_time_half_year',
    value: 180,
    discountLabel: 'payment:half_year_discount',
  },
  {
    type: PricingDuration.Year,
    label: 'workspace:workspace_plan_time_unit3',
    value: 365,
    discountLabel: 'payment:year_discount',
  },
]

export const getDuration = (
  duration?: Nullable<number>,
): Duration | undefined => {
  return DURATIONS.find((item) => item.value === duration)
}

export const getDurationByType = (
  type?: PricingDuration,
): Duration | undefined => {
  return DURATIONS.find((item) => item.type === type)
}

export const convertDurationType = (
  duration: Duration['type'],
): Optional<DurationType> => {
  switch (duration) {
    case PricingDuration.OneDay:
      return DurationType.OneDay
    case PricingDuration.Month:
      return DurationType.Month
    case PricingDuration.Quarter:
      return DurationType.Quarter
    case PricingDuration.HalfYear:
      return DurationType.HalfYear
    case PricingDuration.Year:
      return DurationType.Year
  }
}
